import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=311f5e96&"
import script from "./sign-up.js?vue&type=script&lang=js&"
export * from "./sign-up.js?vue&type=script&lang=js&"
import style0 from "./Signup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports